export default function version(state = '', action) {
    if (action.type === 'VERSION_UPDATE') {
        return state = action.payload;
    }
    return state;
}